<template>
  <div class="carousel-events">
    <flickity class="flickity" ref="flickity" v-if="windowWidth > 1023" :options="flickityOptions" >
      <div v-for="(item,index) in img" :key="index" class="carousel-cell">
        <img
          class="carousel-img"
          :src="item.imgSrc"
        />
      </div>
    </flickity>
     <flickity class="flickity" ref="flickity" v-else-if="windowWidth <= 1000" :options="flickityOptionsMobile" >
      <div v-for="(item,index) in img" :key="index" class="carousel-cell">
        <img
          class="carousel-img"
          :src="item.imgSrc"
        />
      </div>
    </flickity>
  </div>
</template>
<script>
import Flickity from 'vue-flickity'

export default {
  name: 'CarouselEvents',
  components: {
    Flickity
  },
  props: {
    img: Array
  },
  
 
  data() {
    return {
      windowWidth: window.innerWidth,
      flickityOptions: {
        initialIndex: 0,
        prevNextButtons: false,
        pageDots: true,
        wrapAround: true,
        freeScroll: true,
        groupCells: 3
      },
      flickityOptionsMobile: {
        initialIndex: 0,
        prevNextButtons: true,
        pageDots: true,
        wrapAround: true
        
      }
     
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./styles.scss";
/deep/ {
.flickity-viewport{
  height: 150px !important;
  @media (max-width: 1000px) {
    height: 315px !important;
  } 
}
.flickity-page-dots{
  @media (max-width:623px) {
    bottom: -45px;
  }
  
}
}
</style>